import { createClient } from "@supabase/supabase-js";

const EXTERNAL_SUPABASE_URL = "https://famqnuwwqwsuoyisdnjb.supabase.co";
const EXTERNAL_SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZhbXFudXd3cXdzdW95aXNkbmpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0OTcwMTIsImV4cCI6MjA4OTA3MzAxMn0.5Vk7VoA9ecGHD1Q_2VWfr9ntAvh3ml17F-09hzgJmaU";

export const externalSupabase = createClient(
  EXTERNAL_SUPABASE_URL,
  EXTERNAL_SUPABASE_ANON_KEY
);
